// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".pagination{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%}", "",{"version":3,"sources":["style.scss"],"names":[],"mappings":"AAAA,YACE,mBAAa,CAAb,YAAa,CACb,oBAAuB,CAAvB,sBAAuB,CACvB,qBAAmB,CAAnB,kBAAmB,CACnB,UACF","file":"style.scss","sourcesContent":[".pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}"]}]);
// Exports
module.exports = exports;
